<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <span>자동 파일 편집</span>
                        <h1>몇 분이면 MS Word
                            <br>파일 편집 완료</h1>
                        <p>MS Word 문서 자동 편집으로 시간을 절약하세요. 변경 사항 추적 상태로 편집된 파일을 다운로드하여 문서를 초고속으로 완성해 보세요!</p>
                        <a href="https://cloud.trinka.ai/signup?_rg=KR" id="autoEditGetStart" target="_blank">시작하기</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/AutoEditBanner.jpg" alt="banner">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="how_it_work_section" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <div class="howItWorkHeading">
                            <h2>이렇게 사용하세요</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/RegisterAndLogin.png" alt="login">
                                </div>
                                <h3>등록/로그인</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/TypeOrImportFile_icon.png" alt="import">
                                </div>
                                <h3>Auto File Edit
                                    <br>선택 & 파일 업로드</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/improveYourWriting_icon.png" alt="writing">
                                </div>
                                <h3>변경 추적 표시된
                                    <br>파일 다운로드</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="SectionHowItWrok">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/AutoFileEditThumbnail.png" alt="auto file" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>이렇게 사용하세요</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">쉬운 안내 동영상을 보고 자동 파일 편집을 즉시 시작해 보세요.</p>
                        <p style="margin-bottom: 10px;">트링카를 최대한 활용할 수 있도록 단계별로 상세하게 안내해 드립니다. 더 궁금한 사항이 있으신가요?
                            <a style="color: #0000ff;" (click)="scroll(target)" class="link">여기</a>에서 FAQ를 찾아보세요.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    

    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>트링카 자동 파일 편집의 주요 기능</h2>
                        <div class="HeadingSubLine"></div>
                        <p>번거롭게 플러그인을 설치할 필요가 없습니다. 자동 파일 편집 기능을 사용하여 MS Word 파일을 수정해 보세요.</p>
                        <p>트링카는 변경 사항을 추적하여 문서를 자동으로 편집하므로 다운로드하여 작업을 완료할 수 있습니다.</p>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/DownloadTrackChangesEdit.svg" alt="download">
                        <h3>변경 추적 표시된 파일 다운로드</h3>
                        <p>트링카 에디터에서 선택한 다양한 변경 사항을 모두 보여주는 변경 추적 파일을 다운로드하여 최종적으로 마무리하세요. </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/RetainOriginalFormatting.png" alt="formatting">
                        <h3>원래 포맷 유지</h3>
                        <p>원본 포맷이 항상 유지되도록 콘텐츠의 모든 변경 내용은 추적 상태로 업데이트됩니다.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/languageScore_icon.svg" alt="score">
                        <h3>언어 점수</h3>
                        <p>카테코리별 교정 횟수를 기준으로 글의 전반적 품질을 점수로 평가해 줍니다.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/TableofRevisions_icon.svg" alt="icon">
                        <h3>교정사항 표</h3>
                        <p>언어 카테고리별로 교정사항을 상세히 보여주는 표를 통해 어떤 유형의 교정이 이루어지는지 알 수 있습니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/style_guide_icon.svg" alt="style icon">
                        <!-- <img src="../../../assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>스타일 가이드 선호 사항</h3>
                        <p>많이 활용하는 학술 스타일 가이드(AMA 11th, AGU 2017)에 맞게 원고의 문법과 단어 선택을 올바르게 할 수 있습니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="subject area">
                        <!-- <img src="../../../assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>주제분야 & 문서 유형</h3>
                        <p>주제분야 및 원고 유형에 따라 가장
                            <br />관련성이 높은것을 제안 하도록 트링카는
                            <br /> 맞춤화할 수 있습니다.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="uploadOptionSection">
        <div class="container">
            <div class="uploadContentSection">
                <h2>즐겨찾는 클라우드 스토리지에서<br />
                    파일을 업로드하고<br />
                    빠르게 편집해보세요</h2>
                <ul>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="50" height="44" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.6349 15.109C21.6349 15.3108 21.5751 15.5081 21.4629 15.676C21.3508 15.8438 21.1914 15.9746 21.0049 16.0518C20.8184 16.1291 20.6132 16.1493 20.4152 16.1099C20.2173 16.0705 20.0354 15.9733 19.8927 15.8306C19.7499 15.6879 19.6527 15.506 19.6134 15.3081C19.574 15.1101 19.5942 14.9049 19.6714 14.7184C19.7487 14.5319 19.8795 14.3725 20.0473 14.2604C20.2152 14.1482 20.4125 14.0884 20.6143 14.0884C20.885 14.0884 21.1446 14.1959 21.336 14.3873C21.5274 14.5787 21.6349 14.8383 21.6349 15.109V15.109Z" fill="#773795"/>
                                <path d="M24.9945 10.7444C24.9945 10.5326 25.3093 11.3578 21.1944 1.46144C21.1374 1.32431 21.0409 1.20723 20.9172 1.12507C20.7934 1.04291 20.6481 0.999383 20.4996 1.00001H6.24404C6.10455 0.999291 5.96763 1.03753 5.8487 1.11042C5.72977 1.18332 5.63356 1.28796 5.57089 1.41258C0.685141 11.1841 1.02171 10.4729 1 10.6412C1 10.7118 1 10.1961 1 18.2413C1 18.3397 1.01938 18.4371 1.05703 18.528C1.09467 18.6188 1.14986 18.7014 1.21942 18.771C1.28899 18.8406 1.37157 18.8957 1.46246 18.9334C1.55335 18.971 1.65077 18.9904 1.74915 18.9904H24.2453C24.4421 18.9904 24.631 18.913 24.7712 18.7748C24.9114 18.6367 24.9916 18.4489 24.9945 18.2521C24.9945 18.1273 24.9945 10.7986 24.9945 10.7444V10.7444ZM24.9945 10.6901H1.02171H24.9945Z" stroke="#4D4D4D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <p>Trinka My Drive</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="52" height="46" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.25 0C3.65326 0 3.08097 0.237053 2.65901 0.65901C2.23705 1.08097 2 1.65326 2 2.25V11.25C2 11.8467 2.23705 12.419 2.65901 12.841C3.08097 13.2629 3.65326 13.5 4.25 13.5H19.75C20.3467 13.5 20.919 13.2629 21.341 12.841C21.7629 12.419 22 11.8467 22 11.25V2.25C22 1.65326 21.7629 1.08097 21.341 0.65901C20.919 0.237053 20.3467 0 19.75 0H4.25ZM3.5 2.25C3.5 2.05109 3.57902 1.86032 3.71967 1.71967C3.86032 1.57902 4.05109 1.5 4.25 1.5H19.75C19.9489 1.5 20.1397 1.57902 20.2803 1.71967C20.421 1.86032 20.5 2.05109 20.5 2.25V11.25C20.5 11.4489 20.421 11.6397 20.2803 11.7803C20.1397 11.921 19.9489 12 19.75 12H4.25C4.05109 12 3.86032 11.921 3.71967 11.7803C3.57902 11.6397 3.5 11.4489 3.5 11.25V2.25ZM0.75 14.5C0.551088 14.5 0.360322 14.579 0.21967 14.7197C0.0790175 14.8603 0 15.0511 0 15.25C0 15.4489 0.0790175 15.6397 0.21967 15.7803C0.360322 15.921 0.551088 16 0.75 16H23.25C23.4489 16 23.6397 15.921 23.7803 15.7803C23.921 15.6397 24 15.4489 24 15.25C24 15.0511 23.921 14.8603 23.7803 14.7197C23.6397 14.579 23.4489 14.5 23.25 14.5H0.75Z" fill="#4D4D4D"/>
                                <path d="M10 6H14" stroke="#773795" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <p>My Device</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="51" height="47" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1393_8871)">
                                <path d="M5.99953 0L0 3.82228L5.99953 7.64466L12 3.82228L5.99953 0ZM18 0L12 3.82266L18 7.64531L24.0001 3.82266L18 0ZM0 11.4676L5.99953 15.29L12 11.4676L5.99953 7.64531L0 11.4676ZM18 7.64531L12 11.468L18 15.2905L24 11.468L18 7.64531ZM6 16.5723L12.0005 20.3947L18 16.5723L12.0005 12.75L6 16.5723Z" fill="#0061FF"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1393_8871">
                                <rect width="24" height="20.4375" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <p >DropBox</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="50" height="46" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.81444 18.3783L2.87287 20.2064C3.09281 20.5914 3.40894 20.8938 3.78009 21.1137C4.84322 19.7643 5.58309 18.7287 6.00009 18.0071C6.42319 17.2749 6.94322 16.1293 7.56019 14.5707C5.89744 14.3518 4.63744 14.2424 3.78019 14.2424C2.95734 14.2424 1.69734 14.3518 0 14.5707C0 14.9968 0.109969 15.4229 0.329906 15.8079L1.81444 18.3783V18.3783Z" fill="#0066DA"/>
                                <path d="M20.2204 21.1137C20.5917 20.8938 20.9078 20.5914 21.1276 20.2065L21.5675 19.4505L23.6707 15.8079C23.8866 15.4313 24.0003 15.0048 24.0005 14.5707C22.2933 14.3518 21.0357 14.2424 20.2274 14.2424C19.3587 14.2424 18.1009 14.3518 16.4541 14.5707C17.0638 16.1379 17.5769 17.2834 17.9937 18.0071C18.4139 18.7374 19.1562 19.7728 20.2204 21.1137V21.1137Z" fill="#EA4335"/>
                                <path d="M11.9998 6.87291C13.2298 5.38744 14.0775 4.24191 14.5428 3.4365C14.9175 2.78794 15.3299 1.75238 15.7799 0.329906C15.4088 0.109969 14.9827 0 14.5428 0H9.45685C9.01698 0 8.59098 0.12375 8.21973 0.329906C8.79216 1.96134 9.27798 3.12244 9.67698 3.81309C10.118 4.57641 10.8923 5.59631 11.9998 6.87291Z" fill="#00832D"/>
                                <path d="M16.4401 14.5706H7.56028L3.78027 21.1136C4.15134 21.3335 4.57743 21.4435 5.01731 21.4435H18.9831C19.4229 21.4435 19.8491 21.3197 20.2202 21.1135L16.4402 14.5706H16.4401Z" fill="#2684FC"/>
                                <path d="M12.0001 6.87298L8.22009 0.330078C7.84884 0.550016 7.53272 0.852359 7.31278 1.2373L0.329906 13.3336C0.114012 13.7102 0.000285232 14.1366 0 14.5707H7.56019L12.0002 6.87298H12.0001Z" fill="#00AC47"/>
                                <path d="M20.1788 7.28524L16.6872 1.23705C16.4674 0.852115 16.1512 0.549772 15.78 0.329834L12 6.87284L16.4398 14.5706H23.9863C23.9863 14.1444 23.8763 13.7184 23.6564 13.3334L20.1788 7.28524Z" fill="#FFBA00"/>
                            </svg>
                        </div>
                        <p >Google Drive</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="50" height="42" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1393_8873)">
                                <path d="M14.4991 10.3764L19.453 5.63883C18.424 1.62633 14.3371 -0.792141 10.3246 0.236954C8.51775 0.700347 6.9484 1.8204 5.92285 3.37852C5.99945 3.37664 14.4991 10.3764 14.4991 10.3764V10.3764Z" fill="#0364B8"/>
                                <path d="M9.15169 4.27053L9.1515 4.27137C8.20489 3.68508 7.11319 3.37519 5.99972 3.37671C5.97403 3.37671 5.94872 3.37831 5.92303 3.37859C2.61113 3.41965 -0.0405003 6.13784 0.000468414 9.44985C0.0153465 10.6512 0.390719 11.8204 1.07794 12.8059L8.49966 11.8764L14.1897 7.28825L9.15169 4.27053V4.27053Z" fill="#0078D4"/>
                                <path d="M19.4529 5.63899C19.3434 5.63124 19.2337 5.62714 19.1239 5.62671C18.4593 5.62607 17.8017 5.7618 17.1917 6.02552L17.1915 6.02506L14.1895 7.28834L17.499 11.3765L23.4156 12.8147C24.6924 10.4444 23.8059 7.48784 21.4356 6.21096C20.8231 5.88105 20.1471 5.68606 19.4529 5.63909V5.63899Z" fill="#1490DF"/>
                                <path d="M1.07812 12.8058C1.63023 13.5996 2.36625 14.248 3.22333 14.6956C4.08041 15.1432 5.03308 15.3767 6 15.3762H19.1244C20.0044 15.3764 20.868 15.1384 21.6236 14.6874C22.3792 14.2364 22.9987 13.5893 23.4161 12.8146L14.1899 7.28809L1.07812 12.8058V12.8058Z" fill="#28A8EA"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1393_8873">
                                <rect width="24" height="15.4688" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <p >OneDrive</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="cloud_key_features" style="padding: 0;margin: 0 0 60px 0;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>샘플 보고서 보기</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-sm-1"></div>
                <div class="col-sm-10">
                    <div class="viewSampleReportImg">
                        <a href="../../../assets/resources/AutoEdit_sample_edited.docx" target="_blank">전체 보고서 보기
                            <i class="fa fa-arrows-alt" aria-hidden="true"></i>
                        </a>
                        <img src="../../../assets/images/revised-menuscript.png" alt="menuscript">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="cloud_key_features" style="padding: 0;margin: 0 0 60px 0;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>샘플 보고서 보기</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-sm-1"></div>
                <div class="col-sm-10">
                    <div class="viewSampleReportImg">
                        <a href="../../../assets/resources/AutoEdit_sample_edited.docx" target="_blank">전체 보고서 보기
                            <i class="fa fa-arrows-alt" aria-hidden="true"></i>
                        </a>
                        <img src="../../../assets/images/revised-menuscript.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="use_trinka_other_app accomplishBrilliantWrap">
        <div class="container">
            <div class="accomplishBrilliantSection">
                <h2>자동 편집된 Word 파일 가져오기</h2>
                <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">시작하기</a>
            </div>
        </div>
    </div>

    <div class="allAboutTrinkaCredit">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="aboutTrinkaCreditHeading">
                        <h2>자동 파일 편집은 크레딧을 사용합니다</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <div class="creditSectionFeature">
                        <div class="featurePointsCredits">
                            <span>
                                <img src="../../../assets/images/lightbulb.png" alt="icon">
                            </span>
                            <p>한 파일 내에서 5000단어마다 1크레딧을 사용합니다. 무료 크레딧을 사용하다가 필요에 따라 추가 구매하시면 됩니다.</p>
                        </div>
                        <div class="othersPointsForCredits">
                            <p style="margin-bottom: 10px;">크레딧은 필요에 따라 다양한 트링카 기능을 사용할 수 있게 해주는 토큰과 같습니다.</p>
                            <p>프리미엄 사용자에게는 매월 무료로 10크레딧을, 베이직 사용자는 무료로 4크레딧을 드립니다. 자세한 내용을 보려면
                                <a [routerLink]="['/features/credits']">여기</a>를 클릭하세요.</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>자주하는 질문</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        자동 파일 편집 목적으로 파일을 업로드하면 어떻게 되나요?</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <h4>자동 편집 목적으로 파일을 업로드하면 다음을 얻게 됩니다.</h4>
                                        <ol>
                                            <li>모든 변경 사항이 추적 상태로 포함된 편집된 파일을 받게 됩니다. 이러한 변경 사항을 검토하여 Microsoft Word나 기타 호환 가능한
                                                Word 프로세서를 사용하여 수락 또는 거절할 수 있습니다. 이 파일에는 수정 사항을 설명하는 코멘트도 포함되어 있습니다.</li>
                                            <li>수정 횟수, 문법 오류 유형 및 전반적인 글쓰기 품질 점수가 포함된 상세한 보고서도 받게 됩니다.</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        여러 문서를 동시에 일괄 업로드할 수 있나요? 제한이 있을까요?</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>자동 편집을 원하는 만큼 문서를 업로드할 수 있습니다. 업로드할 수 있는 문서의 수에는 제한이 없습니다. 한 파일 내 5000단어 당 1크레딧만
                                            사용됩니다. </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        자동 파일 편집 기능을 직접 써보려면 어떻게 하나요?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>트링카에
                                            <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">가입</a>만 하시면 됩니다. 왼쪽의 탐색 패널에서 자동 파일 편집 옵션을 찾을 수 있습니다.</p>
                                        <p>문서를 업로드한 뒤 편집 시작을 클릭합니다. 짜잔! 단 몇 분 만에 자동 편집된 문서를 받아보세요!</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        자동 파일 편집 기능을 사용하려면 크레딧이 얼마나 필요할까요?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">

                                        <p>베이직 사용자에게는 매월 무료로 4크레딧을, 프리미엄 사용자에게는 매월 무료로 10크레딧을 제공해 드립니다. 자동 파일 편집은 한 파일 내 5000단어
                                            당 1크레딧을 사용합니다.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>

    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>다른 앱에서
                                    <br /> 트링카 사용</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="https://www.trinka.ai/kr/trinkacloud">
                                        <div class="app_name_content" routerLink="/trinkacloud">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                            <h3>클라우드</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/wordplugin">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word 플러그인</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/browser-plugin">
                                        <div class="app_name_content" routerLink="/browser-plugin">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/other_Apps_browser.svg" alt="browser-icon">
                                            <h3>브라우저 플러그인</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                            <h3 style="margin: 0 0 -2px 0;">기업</h3>
                                            <span style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/6Z_PsveCtRQ"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>